import $ from 'jquery';

let $hamburger, $nav, $menu;

function events() {

    $hamburger.on('click', function (event) {
        event.preventDefault();

        $hamburger.toggleClass('is-active');
        $nav.toggleClass('is-open');
        $('html').toggleClass('is-modal-open');
        $('body').toggleClass('is-hamburger-open');
    })

}

function init() {
    $(document).ready(function () {
        $nav = $('nav.header-primary');
        $hamburger = $('button.hamburger');
        $menu = $nav.find('.menu');

        events();
    });
}

export default {init: init};
